export class Switches{
	init(){
		$('.features-list--switch a').on('click', function(e) {
			e.preventDefault();

			var href = $(this).attr('href');

			$(this).closest('.section').fadeOut(function() {
				$(href).fadeIn();				
			});
		});
	}
}